<ng-container [ngTemplateOutlet]="footer()"></ng-container>
